import React from 'react';
import InlineSVG from 'svg-inline-react';

import MinusIcon from '../../../../snippets/icon-minus-new.liquid';
import PlusIcon from '../../../../snippets/icon-plus-new.liquid';
import ShippingTruckIcon from '../../../../snippets/icon-shipping-truck.liquid';
import ShieldIcon from '../../../../snippets/icon-shield.liquid';
import CloseIcon from '../../../../snippets/icon-close-24.liquid';
import PaypalIcon from '../../../../snippets/icon-paypal.liquid';
import AfterpayIcon from '../../../../snippets/icon-afterpay.liquid';
import ArrowIcon from '../../../../snippets/icon-dropdown.liquid';
import CheckmarkIcon from '../../../../snippets/icon-checkmark.liquid';
import TrashIcon from '../../../../snippets/icon-trash.liquid';

const assets = {
  afterpay: AfterpayIcon,
  arrow: ArrowIcon,
  close: CloseIcon,
  checkmark: CheckmarkIcon,
  minus: MinusIcon,
  paypal: PaypalIcon,
  plus: PlusIcon,
  'shipping-truck': ShippingTruckIcon,
  shield: ShieldIcon,
  trash: TrashIcon
};

const Icon = ({
  className, type, style, label
}) => (
    <InlineSVG
      aria-hidden={label ? undefined : true}
      aria-label={label}
      className={className}
      raw={true}
      role={label ? 'img' : undefined}
      src={assets[type]}
      style={style}
    />
);

export default Icon;
